const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function fmtDate(d) {
  if (!d) return "";
  return new Date(d).toLocaleDateString("en-IN", { day: "numeric", month: "long", year: "numeric" });
}

export function readTime(content = "") {
  const words = content.replace(/img:\S+/g, "").split(/\s+/).filter(Boolean).length;
  return Math.max(1, Math.round(words / 200));
}

export const bookmarks = {
  get() {
    try { return JSON.parse(localStorage.getItem("tboi_saved") || "[]"); } catch { return []; }
  },
  toggle(slug) {
    const s = this.get();
    const i = s.indexOf(slug);
    if (i >= 0) s.splice(i, 1); else s.push(slug);
    localStorage.setItem("tboi_saved", JSON.stringify(s));
    return s;
  },
  has(slug) { return this.get().includes(slug); },
};

export async function api(path, { method = "GET", body } = {}) {
  const res = await fetch(`${API}${path}`, {
    method,
    credentials: "include",
    headers: body ? { "Content-Type": "application/json" } : {},
    body: body ? JSON.stringify(body) : undefined,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const d = data.detail;
    const msg = typeof d === "string"
      ? d
      : Array.isArray(d)
        ? d.map((e) => (e && e.msg) || JSON.stringify(e)).join(" ")
        : "Something went wrong";
    throw new Error(msg);
  }
  return data;
}
